import React from "react";

const ShapeSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 480.008 480.008"
    >
      <g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <rect
              x="72.005"
              y="288"
              width="64"
              height="16"
              fill="#fb4a5b"
              data-original="#000000"
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M479.161,380.422l-24-48c-1.355-2.711-4.126-4.422-7.156-4.422h-48v-24c0-4.418-3.582-8-8-8h-160c-4.418,0-8,3.582-8,8    v144c0,4.418,3.582,8,8,8h33.136c4.332,17.046,21.663,27.352,38.708,23.02c11.312-2.875,20.145-11.708,23.02-23.02h58.272    c4.332,17.046,21.663,27.352,38.708,23.02c11.312-2.875,20.145-11.708,23.02-23.02h25.136c4.418,0,8-3.582,8-8v-64    C480.005,382.758,479.716,381.533,479.161,380.422z M296.005,464c-8.837,0-16-7.163-16-16s7.163-16,16-16s16,7.163,16,16    C311.996,456.833,304.838,463.991,296.005,464z M384.005,440h-57.136c-3.627-14.092-16.313-23.956-30.864-24    c-14.551,0.044-27.237,9.908-30.864,24h-25.136V312h144V440z M432.005,344h11.055l16.001,32h-27.056V344z M416.005,464    c-8.837,0-16-7.163-16-16s7.163-16,16-16s16,7.163,16,16C431.996,456.833,424.838,463.991,416.005,464z M464.005,440h-17.136    c-3.627-14.092-16.313-23.956-30.864-24c-5.635,0.032-11.158,1.569-16,4.452V344h16v40c0,4.418,3.582,8,8,8h40V440z"
              fill="#fb4a5b"
              data-original="#000000"
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <rect
              x="176.005"
              y="112"
              width="15.992"
              height="16"
              fill="#fb4a5b"
              data-original="#000000"
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <rect
              x="208.005"
              y="112"
              width="15.992"
              height="16"
              fill="#fb4a5b"
              data-original="#000000"
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <rect
              x="240.005"
              y="112"
              width="15.992"
              height="16"
              fill="#fb4a5b"
              data-original="#000000"
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <rect
              x="272.005"
              y="112"
              width="15.992"
              height="16"
              fill="#fb4a5b"
              data-original="#000000"
              class=""
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M440.7,133.625l-24.785-24.789c-18.427-18.404-43.387-28.77-69.43-28.836h-62.046L246.79,19.762    c-1.463-2.339-4.026-3.761-6.785-3.762h-24c-4.42,0.002-8.002,3.587-8,8.008c0,0.652,0.08,1.301,0.238,1.934L221.758,80h-63.8    L135.669,5.703C134.654,2.318,131.538,0,128.005,0h-40c-4.418,0-8,3.582-8,8v80h0.075c-0.026,2.112,0.79,4.148,2.269,5.656l50,50    c20.629,20.764,48.707,32.41,77.976,32.344h2.179l-19.878,44.754c-1.793,4.037,0.026,8.764,4.063,10.558    c0.235,0.104,0.474,0.197,0.718,0.278l23.984,8c3.36,1.119,7.055-0.103,9.086-3.004L272.861,176h150.265    c13.704,0.025,24.833-11.063,24.859-24.767C447.997,144.628,445.375,138.291,440.7,133.625z M235.571,32l30,48h-27.319l-12.001-48    H235.571z M96.005,16h26.047l19.2,64H96.005V16z M220.79,222.523l-9.965-3.324L237.118,160h27.41L220.79,222.523z     M431.333,154.516c-1.333,3.354-4.599,5.536-8.207,5.484H284.054l2.388-3.414c2.532-3.621,1.649-8.61-1.972-11.142    c-1.344-0.939-2.943-1.444-4.583-1.444h-47.969c-3.163,0-6.029,1.863-7.312,4.754L219.611,160h-9.286    c-25.023,0.055-49.028-9.904-66.664-27.656L107.317,96h239.168c17.442,0.075,34.411,5.677,48.47,16h-58.95v16h76.441    l16.961,16.961C431.969,147.438,432.736,151.24,431.333,154.516z"
              fill="#fb4a5b"
              data-original="#000000"
              class=""
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M196.11,458.121c-5.037-5.409-11.793-8.906-19.118-9.895l30.548-85.535c1.484-4.167-0.691-8.747-4.858-10.231    c-0.048-0.017-0.097-0.034-0.146-0.05l-19.508-6.503l-15.152-83.337c-0.691-3.805-4.005-6.57-7.871-6.57h-32v-24    c0-4.418-3.582-8-8-8h-32c-4.418,0-8,3.582-8,8v24h-32c-3.867,0-7.18,2.766-7.871,6.57l-15.152,83.337L5.474,352.41    c-4.195,1.403-6.457,5.941-5.054,10.135c0.016,0.049,0.033,0.097,0.05,0.146l30.548,85.538    c-7.313,0.996-14.057,4.491-19.087,9.892C9.036,461.767,4.66,463.925,0.005,464v16c8.669-0.047,16.924-3.715,22.77-10.117    c2.895-3.649,7.273-5.808,11.93-5.883c1.69-0.014,3.367,0.299,4.939,0.921c0.067,0.03,0.11,0.094,0.178,0.122    c2.509,1.25,4.787,2.917,6.738,4.93c5.906,6.347,14.17,9.975,22.84,10.027c8.667-0.048,16.92-3.718,22.762-10.121    c5.033-6.574,14.442-7.824,21.016-2.792c1.048,0.802,1.986,1.74,2.789,2.788c5.836,6.405,14.085,10.076,22.75,10.125    c8.665-0.052,16.923-3.682,22.82-10.031c1.934-1.998,4.191-3.657,6.676-4.906c0.072-0.03,0.118-0.098,0.188-0.13    c1.576-0.63,3.259-0.946,4.956-0.932c4.646,0.075,9.013,2.233,11.895,5.879c5.839,6.402,14.089,10.071,22.753,10.121v-16    C203.359,463.925,198.992,461.767,196.11,458.121z M96.005,240h16v16h-16V240z M96.005,449.043    c-5.59,1.729-10.647,4.853-14.695,9.078c-5.046,6.581-14.472,7.825-21.053,2.779c-1.044-0.8-1.978-1.735-2.779-2.779    c-2.483-2.426-5.236-4.56-8.205-6.359l-30.987-86.758L96.005,339.1V449.043z M101.474,320.41l-59.181,19.727L54.681,272h98.648    l12.388,68.137l-59.181-19.727C104.893,319.863,103.117,319.863,101.474,320.41z M158.721,451.814    c-2.934,1.791-5.656,3.908-8.114,6.311c-5.023,6.567-14.419,7.818-20.986,2.795c-1.051-0.804-1.991-1.744-2.795-2.795    c-4.072-4.268-9.177-7.412-14.82-9.127V339.1l77.719,25.904L158.721,451.814z"
              fill="#fb4a5b"
              data-original="#000000"
              class=""
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <rect
              x="304.005"
              y="112"
              width="15.992"
              height="16"
              fill="#fb4a5b"
              data-original="#000000"
              class=""
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
      </g>
    </svg>
  );
};

export default ShapeSVG;
